import { Page } from "../page";
import { ConditionData } from "../stock/QueryConditionData";

export class StockInfoSearchRequest extends Page{

  facility: String | null;
  hubPlantId: String | null;
  sku: String | null;
  storer: String | null;
  brand: String | null;
  specLocType: String[] | null;
  conditions: ConditionData[] | null

  constructor(){
    super();
    this.facility = null;
    this.hubPlantId = null;
    this.sku = null;
    this.storer = null;
    this.brand = null;
    this.specLocType = null;
    this.conditions = null;
  }
}
